<template>
  <div class="home-div">
    <SideBar/>
    <div class="mid">
      <div class="background-container" :class="{ 'background-active': isSearchActive }">
      <div></div>
      <div class="blur-overlay" :class="{ 'blur-active': isSearchActive }"></div>
    </div>
    
    <!-- 搜索容器：添加了入场动画类 -->
    <div class="search-container search-fade-in" :class="{ 'search-active': isSearchActive }">
        <TimesView style="z-index: 3; margin-bottom: 100px;  background: none; color: var(--font-color-5);"/>
      <div class="search-box">
        <div class="bing-icon">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="none" stroke="#fcfcfc" stroke-linecap="round" stroke-linejoin="round" d="M24.139 16.799a1.5 1.5 0 0 0-1.318 1.403c-.023.318-.016.34.703 2.19c1.636 4.209 2.033 5.222 2.1 5.365c.16.345.388.67.672.962c.217.223.36.344.604.506c.426.285.638.364 2.299.856c1.618.479 2.501.797 3.263 1.175c.987.49 1.675 1.047 2.11 1.708c.313.474.59 1.324.71 2.18c.047.335.048 1.075 0 1.377c-.1.657-.304 1.207-.614 1.667c-.165.245-.108.204.132-.094c.68-.845 1.371-2.288 1.724-3.596a10.86 10.86 0 0 0 .167-4.895a10.77 10.77 0 0 0-5.385-7.362c-.175-.096-6.432-3.353-6.54-3.386a2.3 2.3 0 0 0-.474-.073z"></path><path fill="none" stroke="#fcfcfc" stroke-linecap="round" stroke-linejoin="round" d="M20.125 36.203c-.03.025-1.432.893-2.135 1.322a4.7 4.7 0 0 1-1.784.628c-.294.04-.851.04-1.145 0a4.6 4.6 0 0 1-2.157-.873a6 6 0 0 1-.888-.887a4.6 4.6 0 0 1-.828-1.854a4 4 0 0 0-.068-.295c-.013-.013.01.225.054.536c.044.323.138.791.24 1.192c.788 3.098 3.028 5.618 6.062 6.816a10.4 10.4 0 0 0 2.713.67c.36.04 1.38.056 1.757.027c1.725-.13 3.227-.638 4.767-1.612l3.72-2.349l.02-.013s2.875-1.851 3.453-2.418c.24-.236.604-.639.622-.69c.004-.01.068-.11.144-.221q.46-.68.61-1.661c.048-.303.047-1.042 0-1.377c-.09-.647-.298-1.38-.52-1.848c-.366-.766-1.145-1.462-2.263-2.023c-.309-.155-.628-.297-.664-.295c-.016.001-11.69 7.207-11.71 7.224"></path><path fill="none" stroke="#fcfcfc" stroke-linecap="round" stroke-linejoin="round" d="m11.107 34.198l.07.314c.219.982.598 1.69 1.258 2.348a4.44 4.44 0 0 0 3.2 1.323c.877 0 1.637-.22 2.42-.698c.132-.08 2.06-1.27 2.06-1.27s-.007-24.681-.019-24.856a4.43 4.43 0 0 0-1.305-2.868c-.236-.234-.439-.39-1.041-.805c-.3-.207-4.398-3.027-4.574-3.09a1.6 1.6 0 0 0-.702-.087a1.54 1.54 0 0 0-1.35 1.218c-.023.102-.017 28.47-.017 28.47"></path></svg>
  </div>
        <input 
          type="text" 
          class="search-input" 
          v-model="searchKeyword"
          placeholder="搜索或输入网址"
          @focus="activateSearch"
          @blur="deactivateSearch"
          @keyup.enter="handleSearch"
        />
        <button class="search-btn" @click="handleSearch">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" 
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div v-show="!isSearchActive" class="link-more-div" >
        <!-- 文字：添加延迟入场动画 -->
        <div class="link-more link-text-fade-in" @click="toNextPage()">
<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20" viewBox="0 0 512 86"><defs><linearGradient id="logosDiscover0" x1="19.414%" x2="88.601%" y1="9.063%" y2="80.499%"><stop offset="0%" stop-color="#F34F26"></stop><stop offset="100%" stop-color="#F69E35"></stop></linearGradient><filter id="logosDiscover1" width="200%" height="200%" x="-50%" y="-50%" filterUnits="objectBoundingBox"><feMorphology in="SourceAlpha" radius="1" result="shadowSpreadInner1"></feMorphology><feGaussianBlur in="shadowSpreadInner1" result="shadowBlurInner1" stdDeviation="4"></feGaussianBlur><feOffset dx="3" dy="3" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset><feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1"></feComposite><feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"></feColorMatrix></filter><path id="logosDiscover2" d="M270.356.365c-23.982 0-43.44 18.735-43.44 41.857c0 24.584 18.613 42.96 43.44 42.96c24.208 0 43.322-18.62 43.322-42.477c0-23.716-18.986-42.34-43.322-42.34"></path></defs><use fill="url(#logosDiscover0)" fill-rule="evenodd" href="#logosDiscover2"></use><use filter="url(#logosDiscover1)" href="#logosDiscover2"></use><path fill="#b2d1f4" d="M23.746 1.891H.393v81.454h23.231c12.326 0 21.24-2.92 29.06-9.398c9.278-7.695 14.78-19.298 14.78-31.29c0-24.048-17.965-40.766-43.718-40.766m18.572 61.177c-5.021 4.53-11.486 6.488-21.76 6.488H16.29V15.684h4.268c10.274 0 16.491 1.834 21.76 6.592c5.495 4.886 8.772 12.452 8.772 20.265c0 7.83-3.277 15.66-8.772 20.527m32.48 20.277H90.67V1.891H74.8zm54.728-50.209c-9.539-3.534-12.346-5.865-12.346-10.246c0-5.134 4.998-9.039 11.849-9.039c4.763 0 8.671 1.953 12.836 6.58l8.295-10.853C143.32 3.581 135.139.532 126.214.532c-14.398 0-25.399 10.02-25.399 23.32c0 11.246 5.126 16.981 20.032 22.369c6.232 2.187 9.4 3.646 10.992 4.643c3.175 2.077 4.77 4.998 4.77 8.415c0 6.606-5.257 11.484-12.351 11.484c-7.574 0-13.674-3.782-17.34-10.865L96.67 69.802c7.314 10.733 16.11 15.512 28.214 15.512c16.488 0 28.084-11.007 28.084-26.758c0-12.949-5.36-18.816-23.442-25.42m28.448 9.522c0 23.965 18.816 42.525 43.006 42.525c6.839 0 12.701-1.352 19.915-4.759V61.727c-6.36 6.358-11.98 8.916-19.19 8.916c-15.996 0-27.363-11.606-27.363-28.102c0-15.626 11.722-27.964 26.638-27.964c7.561 0 13.311 2.685 19.915 9.158V5.04C213.933 1.51 208.183.054 201.343.054c-24.067 0-43.369 18.935-43.369 42.604m191.652 13.948L327.883 1.891h-17.346l34.58 83.535h8.543L388.843 1.89h-17.217zm46.44 26.74h45.065v-13.79h-29.189V47.555h28.072V33.763h-28.072v-18.08h29.189V1.892h-45.066zM504.02 25.93c0-15.259-10.49-24.039-28.823-24.039H451.62v81.454h15.895V50.608h2.08l21.975 32.737h19.544l-25.667-34.31c11.988-2.452 18.573-10.639 18.573-23.105m-31.882 13.452h-4.623V14.7h4.877c9.915 0 15.287 4.165 15.287 12.092c0 8.177-5.372 12.59-15.541 12.59"></path></svg></div>
      </div>
    </div>
    </div>
    
    <BottomTip v-show="!isSearchActive" style="position: fixed; bottom: 0; z-index: 100" />
  </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import TimesView from '@/components/tip/TimesView.vue';
import router from '@/router';

export default {
  name: 'Searchbing',
  components: {
    SideBar,
    BottomTip,
    TimesView
  },
  data() {
    return {
      searchKeyword: '',
      isSearchActive: false,
      quickLinks: [
        {name: '原神', icon: '🎮', url: 'https://ys.mihoyo.com/main/'},
        { name: '新闻', icon: '📰', url: 'https://news.sina.com.cn' },
        { name: '视频', icon: '🎬', url: 'https://www.bilibili.com' }
      ]
    };
  },
  methods: {
    toNextPage(){
      router.push("/transfer");
    },
    activateSearch() {
      this.isSearchActive = true;
    },
    deactivateSearch() {
      setTimeout(() => {
        this.isSearchActive = false;
      }, 200);
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        window.open(`https://www.bing.com/search?q=${encodeURIComponent(this.searchKeyword)}`, '_blank');
      }
    },
    navigateTo(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped>
/* ====================== 新增：页面入场动画 ====================== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 搜索框整体入场动画 */
.search-fade-in {
  animation: fadeInUp 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

/* 下方文字延迟入场（更有层次感） */
.link-text-fade-in {
  opacity: 0;
  animation: fadeInUp 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.4s forwards;
}
/* =============================================================== */

.home-div {
  width: 100%;
  height: 100vh;
  margin: 0;
  position: relative;
  overflow: hidden;
}

.mid{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.background-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.bing-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 16px;
  opacity: 0.85;
  transition: opacity 0.3s ease;
}
.search-box:focus-within .bing-icon {
  opacity: 1;
}

.background-active {
  transform: scale(1.05);
  filter: brightness(0.8);
}

.blur-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(0px);
  background-color: rgba(0, 0, 0, 0);
  transition: all 0.6s ease;
}

.blur-active {
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.3);
}

.search-container {
  padding-top: 100px;
  z-index: 2;
  width: 100%;
  max-width: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
  transition: all 0.5s ease;
}

.search-active {
  transform: translateY(-20px);
}

.search-box {
  width: 100%;
  display: flex;
  align-items: center;
  background: rgba(20, 20, 20, 0.3);
  backdrop-filter: blur(18px);
  border-radius: 50px;
  padding: 2px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.search-box:focus-within {
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  transform: scale(1.02);
}

.search-input {
  flex: 1;
  padding: 2px 5px;
  border: none;
  background: transparent;
  font-size: 15px;
  color: #FFFFFF;
  outline: none;
}

.search-input::placeholder {
  text-align: center;
  color: rgb(243, 240, 240);
}

.search-btn {
  width: 40px;
  height: 35px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 5px;
}

.search-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.quick-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 50px;
  width: 100%;
  max-width: 500px;
}

.link-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  cursor: pointer;
  transition: all 0.3s ease;
  color: #FFFFFF;
}

.link-more-div{
  width: 100%; 
  padding-top: 50px; 
  display: flex; 
  justify-content: center;
}

.link-more {
  font-size: 30px;
  color: var(--font-color-6);
  letter-spacing: 2px;
    cursor: pointer;
    position: relative;
    padding: 5px 0;
    transition: all 0.3s ease;
    display: block;
}

.link-more::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: var(--font-color-6);
    transition: width 0.3s ease;
}

.link-more:hover::after {
    width: 100%;
}

.link-more {
    transition: color 0.3s ease;
}

.link-more:hover {
    color: var(--font-color-6);
}

.link-item:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-5px);
}

.link-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.link-name {
  font-size: 14px;
  font-weight: 500;
}

@media only screen and (max-width: 768px) {
  .search-container {
    padding-top: 0 !important;
    width: 90%;
    min-height: calc(100vh - 125px);
  }
  
  .quick-links {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    margin-top: 40px;
  }
  
  .search-input {
    font-size: 16px;
    padding: 15px 20px;
  }

  .link-more-div{
  width: 100%; 
  padding-top: 50px; 
  display: flex; 
  justify-content: center;
}
}
</style>